<div class="card-header bg-white d-flex justify-content-between align-items-center">
    <div>
        <i class="fas fa-users text-gray text-opacity-50"></i>
        Grupo Familiar
    </div>

    <div class="btn-group my-n1">
        <button class="btn btn-white btn-sm border-0 text-gray" (click)="getFamily()" aria-label="Actualizar grupo familiar"><i class="fas fa-sync"></i>
        </button>
    </div>


</div>
@if(showSpinner){
<app-state-display state="loading"></app-state-display>
}@else{
<div class="car-body p-3 text-dark fw-bold">
    @if(family.length > 0){
    <div class="table-responsive">
    <table class="table table-sm table-hover">
        <thead>
            <th>N°</th>
            <th>Nombres</th>
            <th>Apellido Paterno</th>
            <th>Apellido Materno</th>
            <th>Edad</th>
            <th>Tipo Aseg</th>
            @if(permissions?.change_insured || permissions?.exclution){
            <th class="text-center"><i class="fas fa-cogs"></i></th>
            }
        </thead>

        <tbody>
            @for(person of family; track person; let i = $index){
            <tr>
                <td>{{i + 1}}</td>
                <td>{{person.insured.names}}</td>
                <td>{{person.insured.surname}}</td>
                <td>{{person.insured.lastname}}</td>
                <td>{{person.insured.age}}</td>
                <td>{{person.relationship.name}}</td>
                <td class="text-center">
                    <button class="btn btn-outline-primary btn-xs" (click)="changeInsured(person.insured.rut)"
                        ngbTooltip="Ver detalles" placement="top" aria-label="Ver detalles de {{person.insured.names}}"><i class="fas fa-eye"></i></button>
                    <button class="btn btn-outline-danger btn-xs mx-2"
                        (click)="open(exclutionRequest, person.insured._id)" ngbTooltip="Dar de Baja" placement="top" aria-label="Dar de baja a {{person.insured.names}}"><i
                            class="fas fa-user-minus"></i></button>
                
                </td>
            </tr>
            }
        </tbody>


    </table>
    </div>
    }@else {
    <div class="d-flex justify-content-center">
        <span>Aún no se registran cargas en esta póliza</span>
    </div>
    }
</div>
}





<ng-template #exclutionRequest let-c="close" let-d="dismiss">


    <div class="modal-header d-flex justify-content-between">
        <h5>Solicitud de Baja:</h5>
        <button type="button" class="close btn btn-sm btn-white m-r-1" (click)="d('Cross click')"><span
                aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body" [formGroup]="exclutionForm">
        <div class="row mt-3 mb-3">
            <div class="col-md-4">
                <label for="dateFinish" class="fw-bold">Fin de Vigencia</label>
                <input type="date" class="form-control" formControlName="dateFinish" id="dateFinish">
            </div>
             <div class="col-md-12">
                <label for="voteDetail" class="fw-bold">Detalle de la Baja</label>
                <textarea rows="5" class="form-control" formControlName="voteDetail" id="voteDetail"></textarea>
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-danger btn-xs" (click)="d('Close')"><i class="fas fa-times"></i> Cancelar</button>
        <button class="btn btn-primary btn-xs" [disabled]="exclutionForm.invalid" (click)="exclusionInsured()"><i class="fas fa-check"></i> Aceptar</button>
    </div>
</ng-template>